import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SUPERADMIN_ROUTES, ProtectedRoute, UserRole } from '@dukene/shared';

// Layouts
import AdminLayout from './components/layout/AdminLayout';
import AuthLayout from './components/layout/AuthLayout';

// Auth Pages
import Login from './pages/auth/Login';

// Dashboard Pages
import Dashboard from './pages/Dashboard';
import Organisations from './pages/Organisations';
import Stores from './pages/stores/Stores';
import StoreDetail from './pages/stores/StoreDetail';
import Users from './pages/users/Users';
import UserDetail from './pages/users/UserDetail';
import Affiliates from './pages/affiliates/Affiliates';
import CreateAffiliate from './pages/affiliates/CreateAffiliate';
import AffiliateDetail from './pages/affiliates/AffiliateDetail';
import Analytics from './pages/Analytics';
import ServerMetrics from './pages/ServerMetrics';
import Payments from './pages/Payments';
import Revenue from './pages/Revenue';
import Shipping from './pages/Shipping';
import System from './pages/System';
import Settings from './pages/Settings';
import AdminWhatsAppCRM from './pages/whatsapp/AdminWhatsAppCRM';
import Suppliers from './pages/suppliers/Suppliers';
import SupplierForm from './pages/suppliers/SupplierForm';
import Email from './pages/Email';
import ComposeEmail from './pages/ComposeEmail';
import EmailDetail from './pages/EmailDetail';
import Profile from './pages/Profile';
import OrderRoutes from './pages/OrderRoutes';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
        </Route>

        {/* Admin Routes - Protected */}
        <Route element={<ProtectedRoute allowedRoles={[UserRole.ADMIN, UserRole.SUPER_ADMIN]}><AdminLayout /></ProtectedRoute>}>
          <Route path={SUPERADMIN_ROUTES.DASHBOARD} element={<Dashboard />} />
          <Route path={SUPERADMIN_ROUTES.ORGANISATIONS} element={<Organisations />} />
          <Route path={SUPERADMIN_ROUTES.STORES} element={<Stores />} />
          <Route path={SUPERADMIN_ROUTES.STORES_DETAIL} element={<StoreDetail />} />
          <Route path={SUPERADMIN_ROUTES.USERS} element={<Users />} />
          <Route path={SUPERADMIN_ROUTES.USERS_DETAIL} element={<UserDetail />} />
          <Route path={SUPERADMIN_ROUTES.AFFILIATES} element={<Affiliates />} />
          <Route path={SUPERADMIN_ROUTES.AFFILIATES_CREATE} element={<CreateAffiliate />} />
          <Route path={SUPERADMIN_ROUTES.AFFILIATES_DETAIL} element={<AffiliateDetail />} />
          <Route path={SUPERADMIN_ROUTES.ANALYTICS} element={<Analytics />} />
          <Route path={SUPERADMIN_ROUTES.METRICS} element={<ServerMetrics />} />
          <Route path={SUPERADMIN_ROUTES.PAYMENTS} element={<Payments />} />
          <Route path={SUPERADMIN_ROUTES.REVENUE} element={<Revenue />} />
          <Route path={SUPERADMIN_ROUTES.SHIPPING} element={<Shipping />} />
          <Route path={SUPERADMIN_ROUTES.SYSTEM} element={<System />} />
          <Route path={SUPERADMIN_ROUTES.SETTINGS} element={<Settings />} />
          <Route path={SUPERADMIN_ROUTES.WHATSAPP} element={<AdminWhatsAppCRM />} />
          <Route path={SUPERADMIN_ROUTES.SUPPLIERS} element={<Suppliers />} />
          <Route path={SUPERADMIN_ROUTES.SUPPLIERS_NEW} element={<SupplierForm />} />
          <Route path={SUPERADMIN_ROUTES.SUPPLIERS_DETAIL} element={<SupplierForm />} />
          <Route path={SUPERADMIN_ROUTES.EMAIL} element={<Email />} />
          <Route path={SUPERADMIN_ROUTES.EMAIL_COMPOSE} element={<ComposeEmail />} />
          <Route path={SUPERADMIN_ROUTES.EMAIL_DETAIL} element={<EmailDetail />} />
          <Route path={SUPERADMIN_ROUTES.PROFILE} element={<Profile />} />
          <Route path={SUPERADMIN_ROUTES.ORDER_ROUTES} element={<OrderRoutes />} />
        </Route>

        {/* Redirect root to dashboard */}
        <Route path="*" element={<Navigate to={SUPERADMIN_ROUTES.DASHBOARD} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
